import { Text } from "components/shared/text";
import { roundTo1Decimals } from "utils";

export const SolutionDetailListItemTable: React.FC<{
  rows: { label: string; value?: string | number | boolean }[];
}> = ({ rows }) => {
  return (
    <group
      data-width="auto"
      data-direction="column"
      data-radius="5"
      data-contain=""
    >
      {rows.map(({ label, value }, i) => (
        <group key={label} data-wrap="no" data-width="auto">
          <group
            data-length="260"
            data-height="40"
            data-space-horizontal="10"
            data-align="center"
            data-fit="2"
            data-background={i == 0 ? "accent-dark" : "main"}
            data-color="white"
          >
            <Text data-position="left" data-weight="600" data-ellipsis="">
              {label}
            </Text>
          </group>
          <group
            data-length="260"
            data-height="40"
            data-space-horizontal="10"
            data-align="center"
            data-fit="1"
            data-background={i == 0 ? "accent-semilight" : ""}
          >
            <Text
              data-position="left"
              data-color="grey-color-dark"
              data-weight="600"
              data-ellipsis=""
            >
              {typeof value === "number"
                ? roundTo1Decimals(value)
                : value?.toString() || "-"}
            </Text>
          </group>
        </group>
      ))}
    </group>
  );
};
